import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-fnf-dashboard',
  templateUrl: './fnf-dashboard.component.html',
  styleUrls: ['./fnf-dashboard.component.scss']
})
export class FnfDashboardComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
